// formats a value of 0 (zero) to display as a - (dash)
(function () {
    'use strict';
    angular
        .module('app')
        .directive('zeroAsDash',
            () => {
                return {
                    require: 'ngModel',
                    link: (scope, elm, attrs, ctrl) => {
                        ctrl.$formatters.push(value => {
                            if (value == 0) {
                                return '-';
                            }
                            return value;
                        });
                    }
                };
            });
})();
